var t = /^(br|hy|us|wr|text-si|scroll-snap-t)/,
    e = /^(ap|us|tab-|border-e|margin-e|margin-s|padding-e|padding-s|border-sta)/,
    r = /^(ap|br|hy|us|wr|mas|colu|clip-|box-de|font-k|text-e|font-fe|shape-i|text-or|text-si|border-e|margin-e|margin-s|padding-e|padding-s|border-sta|background-cl|scroll-snap-t|text-decoration-)/,
    s = /^(pos|background-cl)/,
    a = {},
    n = function n(s) {
  return a[s] ? a[s] : a[s] = 1 * t.test(s) | 2 * e.test(s) | 4 * r.test(s);
},
    o = function o(t, e) {
  return s.test(t) ? e.replace(/(sticky|text)/, "-webkit-$1, $1") : e;
};

export { n as prefixProperty, o as prefixValue };